import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { UserHourBankModel } from 'app/models/user_hour_bank.model';

@Injectable({ providedIn: 'root' })
export class UserHourBankService extends BaseService<UserHourBankModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'userHourBank');
    }
}
